import { render, staticRenderFns } from "./ChannelDashboard.vue?vue&type=template&id=e044e46e&scoped=true"
import script from "./ChannelDashboard.vue?vue&type=script&lang=js"
export * from "./ChannelDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e044e46e",
  null
  
)

export default component.exports